import React from 'react';

const Services = ({ services }) => (
  <section id="services" className="py-16 text-center bg-pink-50">
    <h2 className="text-3xl font-semibold text-purple-800 mb-8">Our Services</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 px-4 md:px-8 lg:px-16">
      {services.map((service, index) => (
        <div key={index} className="p-6 border border-pink-200 rounded-lg bg-pink-100">
          <img src={service.image} alt={service.title} className="rounded-full mx-auto mb-4" />
          <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
          <p className="text-gray-600">{service.description}</p>
        </div>
      ))}
    </div>
  </section>
);

export default Services;